import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import _ from 'lodash';

export const FeaturedContentWithImage = ({
  imageSrc,
  alt,
  headline,
  content,
  link,
  linkText,
  showLinkAsButton,
}) => {
  let anchorClass = 'link';
  if (showLinkAsButton) {
    anchorClass = 'button secondary';
  }
  return (
    <div className="teaser">
      <div className="teaser--image">
        <img src={`${imageSrc}`} alt={alt} />
      </div>
      <div className="teaser--content">
        {headline && <h2>{headline}</h2>}
        <p>{content}</p>
        <p>
          <a className={anchorClass} href={link}>
            {linkText}
          </a>
        </p>
      </div>
    </div>
  );
};

export const FeaturedContent = ({ props }) => {
  const buildItem = ({ node }, index) => {
    return (
      <div
        key={index}
        className="featured-content featured-content__no-image cell small-6"
      >
        <Link to={`/blog/${node.slug}`}>
          <h4>{node.frontmatter.title}</h4>
          <p>{node.frontmatter.description}</p>
        </Link>
      </div>
    );
  };

  return (
    <div className="grid-x grid-margin-x grid-margin-y">
      {_.map(props.edges, buildItem)}
    </div>
  );
};
